import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../services/i18nService';

class Message extends React.PureComponent {
    static propTypes = {
        model: PropTypes.object.isRequired,
        extraClasses: PropTypes.string,
        id: PropTypes.string,
        handleClose: PropTypes.func,
        showClose: PropTypes.bool,
        styles: PropTypes.object,
    };

    render() {
        const { extraClasses = '', model, styles } = this.props;
        /* The time is set by the application server as a UTC time , format it for ISO datetime format */
        const date = new Date(`${model.timestamp}Z`);
        const timeAndDateToShow = `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
        const senderFullName = `${model.senderFirstName} ${model.senderLastName}`;
        return (
            <div key={model.messageId} className={`${extraClasses} messageWrapper`} id={this.props.id} style={styles} role="alertdialog">
                <h3 className="messageTitle">
                    {model.subject}
                </h3>
                <p className="messageContent">{model.body}</p>
                {
                    model.timestamp && model.senderFirstName && model.senderLastName
                        ? <p className="whenAndWho">
                            {`${timeAndDateToShow} ${senderFullName}`}
                        </p>
                        : null
                }
                {this.props.showClose ?
                    <div className="message-close-wrapper">
                        <button className="btn btn-message-close" onClick={this.props.handleClose}>
                            {t('general.close')}
                        </button>
                    </div>
                    :
                    null
                }
            </div>
        );
    }
}

export default Message;
